import { useLocale } from './useLocale';

export function useNumberFormat() {
  const { locale, isDE } = useLocale();

  const formatCurrency = (value?: string | number): string => {
    if (!value && value !== 0) {
      return '';
    }

    const hasPennies = !Number.isInteger(Number(value));
    const currencyCode = isDE ? 'EUR' : 'GBP';
    const currencyFormatter = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currencyCode,
      minimumFractionDigits: hasPennies ? 2 : 0,
      maximumFractionDigits: hasPennies ? 2 : 0,
    });

    return currencyFormatter.format(Number(value));
  };

  const formatPercentage = (value?: string | number): string => {
    if (!value && value !== 0) {
      return '';
    }

    const percentageFormatter = new Intl.NumberFormat(locale, {
      style: 'percent',
      maximumFractionDigits: 2,
    });

    return percentageFormatter.format(Number(value));
  };

  return {
    formatCurrency,
    formatPercentage,
  };
}
